import { Button } from '@/components/Button';
import { twMerge } from 'tailwind-merge';

interface PdfViewButtonProps {
  href: string;
  buttonText: string;
  containerClassName?: string;
  buttonClassName?: string;
  iconClassName?: string;
  textClassName?: string;
}

export const PdfViewButton = ({
  href,
  buttonText,
  containerClassName,
  buttonClassName,
  iconClassName,
  textClassName,
}: PdfViewButtonProps) => {
  return (
    <div className={twMerge('flex', containerClassName)}>
      <a className="inline-block" href={href} target="_blank">
        <Button
          text={buttonText}
          leftIcon={
            <i
              className={twMerge(
                '-mt-0.5 ki-outline ki-eye text-white text-[20px]',
                iconClassName,
              )}
            />
          }
          buttonClassName={twMerge('pl-3.5 pr-4', buttonClassName)}
          textClassName={twMerge('text-white text-2sm', textClassName)}
        />
      </a>
    </div>
  );
};
